import React, { useState } from "react";
import axios from "axios";
import { API_BASE } from "../config/api";
import "./BespokeJewelryPage.css";

const BespokeJewelryPage = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    description: ""
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(`${API_BASE}/bespoke/submit`, form);
      
      if (response.data.success) {
        setSubmitted(true);
        setForm({
          name: "",
          email: "",
          phone: "",
          city: "",
          state: "",
          description: ""
        });
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to submit request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bespoke-container">
      <h1>Create Your Masterpiece</h1>
      <div className="bespoke-main-content">
        <div className="bespoke-left-section">
          <section className="bespoke-info-section">
            <h2>Your Vision, Our Craft</h2>

            <p>
              At <span className="brand-name-gold">Panchali Jewels</span>, we believe every piece of jewelry should tell a story.
              Our bespoke jewelry service allows you to transform your ideas into
              beautifully crafted pieces that reflect your personality, style, and
              memorable moments.
            </p>

            <p>
              Whether it is an engagement ring, necklace, bracelet, or a spiritual
              ornament, our team works closely with you to understand your vision.
              You can select from premium materials such as gold, silver, platinum,
              and carefully chosen gemstones to create a design that truly belongs to you.
            </p>

            <p>
              Our master artisans combine traditional craftsmanship with modern
              techniques to craft jewelry that is both elegant and durable.
              Every piece is made with attention to detail, ensuring that the final
              creation becomes a timeless treasure you can cherish for years.
            </p>

           

            <div className="bespoke-features">
              <div className="feature">
                <span className="feature-icon">✨</span>
                <span>Custom Design Consultation</span>
              </div>
              <div className="feature">
                <span className="feature-icon">💎</span>
                <span>Premium Materials</span>
              </div>
              <div className="feature">
                <span className="feature-icon">🎨</span>
                <span>Handcrafted Excellence</span>
              </div>
            </div>
          </section>
        </div>
        <div className="bespoke-right-section">
          <section className="bespoke-form-section">
            <h2>Start Your Custom Journey</h2>
            {submitted ? (
              <div className="bespoke-success">
                Thank you for your interest. Our team will contact you within 24 hours to discuss your custom design requirements.
              </div>
            ) : (
              <form className="bespoke-form" onSubmit={handleSubmit}>
                {error && <div className="bespoke-error">{error}</div>}
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">
                      Full Name <span className="required-asterisk">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      required
                      autoComplete="off"
                      placeholder="Enter your full name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">
                      Email Address <span className="required-asterisk">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                      autoComplete="off"
                      placeholder="Enter your email address"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">
                      Phone Number <span className="required-asterisk">*</span>
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      required
                      autoComplete="off"
                      placeholder="Enter your phone number"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="city">
                      City <span className="required-asterisk">*</span>
                    </label>
                    <input
                      type="text"
                      id="city"
                      name="city"
                      value={form.city}
                      onChange={handleChange}
                      required
                      autoComplete="off"
                      placeholder="Enter your city"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="state">
                    State <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    id="state"
                    name="state"
                    value={form.state}
                    onChange={handleChange}
                    required
                    autoComplete="off"
                    placeholder="Enter your state"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="description">
                    Jewelry Description <span className="required-asterisk">*</span>
                  </label>
                  <textarea
                    id="description"
                    name="description"
                    value={form.description}
                    onChange={handleChange}
                    required
                    rows={6}
                    placeholder="Please describe your custom jewelry requirements. Include details like:&#10;- Type of jewelry (ring, necklace, bracelet, etc.)&#10;- Preferred materials (gold, silver, platinum, etc.)&#10;- Gemstone preferences&#10;- Design style (modern, vintage, classic, etc.)&#10;- Any special requirements or personal touches&#10;- Budget range (optional)&#10;- Sample images/photos if any (optional)"
                  />
                </div>
                <button type="submit" className="bespoke-submit-btn" disabled={loading}>
                  {loading ? "Submitting..." : "Submit Request"}
                </button>
              </form>
            )}
          </section>
        </div>
      </div>
      <section className="bespoke-process-section">
        <h2>How It Works</h2>
        <div className="process-steps">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Consultation</h3>
            <p>We'll discuss your vision, preferences, and requirements in detail.</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h3>Design</h3>
            <p>Our designers create sketches and 3D models based on your input.</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h3>Crafting</h3>
            <p>Expert artisans handcraft your piece with precision and care.</p>
          </div>
          <div className="step">
            <div className="step-number">4</div>
            <h3>Delivery</h3>
            <p>Your unique jewelry is delivered with a lifetime guarantee.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BespokeJewelryPage;
